import { Button, DialogActions, Icon } from '@mui/material'
import Grid from '@mui/material/Grid'
import classNames from 'classnames'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import ContainedIconButton from 'ui/components/ContainedIconButton/ContainedIconButton'

import styles from './AddDialogActions.module.less'

type AddDialogActionsProps = {
  onDelete?: () => void
  onCancel: () => void
  hasEditPermission?: boolean
  editing: boolean
  saveButtonDisabled: boolean
  isSubmitting: boolean
}

export default function AddDialogActions({
  onDelete,
  onCancel,
  hasEditPermission,
  editing,
  saveButtonDisabled,
  isSubmitting,
}: AddDialogActionsProps): ReactElement {
  const { t } = useTranslation()

  return (
    <DialogActions style={{ justifyContent: `flex-start` }}>
      <Grid container spacing={1} direction="row" justifyContent="flex-start">
        <Grid container justifyContent="flex-start" size={{ xs: 4 }}>
          {editing && onDelete ? (
            <>
              <Button
                className={styles.AddDialogActions_DeleteButton}
                color="secondary"
                disabled={!hasEditPermission || isSubmitting}
                onClick={() => {
                  onDelete()
                }}
              >
                <Icon
                  className={classNames(styles.AddDialogActions_ButtonIcon, `fas fa-trash`)}
                  style={{ color: `red` }}
                  fontSize="small"
                />
                {t(`Remove setting`)}
              </Button>
            </>
          ) : null}
        </Grid>

        <Grid container justifyContent="flex-end" spacing={1} size={{ xs: 8 }}>
          <Grid>
            <Button
              disabled={isSubmitting}
              variant="contained"
              color="secondary"
              onClick={() => {
                onCancel()
              }}
            >
              {t(`Cancel`)}
            </Button>
          </Grid>
          <Grid>
            <ContainedIconButton
              type="submit"
              color="primary"
              disabled={!hasEditPermission || saveButtonDisabled}
              icon={editing ? `fal fa-save` : `fal fa-plus`}
              label={editing ? t(`Save`) : t(`Add`)}
            />
          </Grid>
        </Grid>
      </Grid>
    </DialogActions>
  )
}
